


















































import { Component, Vue } from "vue-property-decorator";
import { MessageService } from "@/shared/services/message-service";
import { pacientes_leads } from "@/shared/dtos/pacientes_leads";
import pacientesLeadsModule from "@/store/modules/pacientes_leads-module";

@Component({ name: "PacientesLeadsManager" })
export default class PacientesLeadsManager extends Vue {
  public loading: boolean = false;
  public saving: boolean = false;
  public dialogOpen: boolean = false;
  public isEditMode: boolean = false;
  public searchText: string = "";
  public form: pacientes_leads = new pacientes_leads();
  public fechaNacimientoInput: string = "";
  public headers: any[] = [
    { text: "Nombre", value: "nombre" }, { text: "Apellidos", value: "apellidos" }, { text: "Telefono", value: "telefono" },
    { text: "Email", value: "email" },  { text: "Acciones", value: "actions", sortable: false }
  ];
  public mounted() { this.refresh(); }
  public get rows(): pacientes_leads[] { return pacientesLeadsModule.rows; }
  public get filteredRows(): pacientes_leads[] {
    const s = (this.searchText || "").toLowerCase().trim();
    if (!s) return this.rows;
    return this.rows.filter(x => (x.nombre + " " + x.apellidos + " " + x.telefono + " " + x.email).toLowerCase().indexOf(s) !== -1);
  }
  public async refresh() { this.loading = true; try { await pacientesLeadsModule.getRows(); } finally { this.loading = false; } }
  public openCreate() { this.isEditMode = false; this.form = new pacientes_leads(); this.fechaNacimientoInput = ""; this.dialogOpen = true; }
  public openEdit(item: pacientes_leads) {
    this.isEditMode = true; this.form = new pacientes_leads(item);
    this.fechaNacimientoInput = this.form.fecha_nacimiento ? this.form.fecha_nacimiento.toISOString().substr(0, 10) : "";
    this.dialogOpen = true;
  }
  public async save() {
    if (!this.form.nombre || !this.form.telefono) { MessageService.alert("Validacion", "Nombre y telefono son obligatorios", MessageService.TypeWarning); return; }
    this.saving = true;
    try {
      this.form.nombre = (this.form.nombre || "").trim();
      this.form.apellidos = (this.form.apellidos || "").trim();
      this.form.telefono = (this.form.telefono || "").trim();
      this.form.email = (this.form.email || "").trim();
      this.form.documento = (this.form.documento || "").trim();
      this.form.observaciones = (this.form.observaciones || "").trim();
      this.form.fecha_nacimiento = this.fechaNacimientoInput ? new Date(this.fechaNacimientoInput + "T00:00:00") : null;
      if (this.isEditMode) await pacientesLeadsModule.modificar(this.form); else await pacientesLeadsModule.guardar(this.form);
      this.dialogOpen = false; await this.refresh();
    } finally { this.saving = false; }
  }
  public remove(item: pacientes_leads) {
    MessageService.confirm("Quieres eliminar este lead?", "Confirmacion", async (res: boolean) => { if (!res) return; await pacientesLeadsModule.eliminar(item); await this.refresh(); });
  }
}
